import React from 'react';
import ZsFormikTextField from "src/components/atoms/zsTextField";
import {validate} from "src/utils/yup";
import * as Yup from 'yup';
import {getIn, useFormikContext} from "formik";

export interface ICustomerNumberProps {
    disabled? : boolean;
    authentication?: (customerNumber: string, zipcode: string) => void;
}

export function CustomerNumber(props: ICustomerNumberProps) {

    const { values } = useFormikContext();

    const zipcode = getIn(values, 'zc');

    const handleKeyDown = (event: any) => {
        if (event.target.value.length === 8 && zipcode.length === 5) {
            if (props.authentication) {
                props.authentication(event.target.value, zipcode);
            }
        }
    }

    return (
        <>
            <label><span style={{color: '#F00'}}>*</span> Kundennummer</label>
            <ZsFormikTextField name="customerNumber"
                               type="onlyNumbers"
                               onChange={handleKeyDown}
                               disabled={props.disabled}
                               inputProps={{maxLength: 8}}
                               validate={validate(Yup.string()
                                   .matches(/^[0-9]{8}$/, 'Ihre Kundennummer muss aus 8 Ziffern bestehen.')
                                   .required('Bitte Ihre Kundennummer angeben.'))}
                               required/>
        </>
    );

}